// eslint-disable-next-line import/prefer-default-export
export const smartCardFields = {
  SmartCardTimeout: {
    id: 'SmartCardTimeout',
    title: 'Smart Card timeout',
    type: 'text',
  },
  SmartCardType: {
    id: 'SmartCardType',
    title: 'Smart Card Type',
    type: 'select',
    options: [
      { name: 'USB Card reader', value: 'usb' },
      { name: 'Swedbank terminal Card reader', value: 'swedbank' },
    ],
  },
  SmartCardHTTPDevicePort: {
    id: 'SmartCardHTTPDevicePort',
    title: 'Smart Card Device Port',
    type: 'text',
  },
};
